import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Home() {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-4">
        <p>
          {t("monitor_status_in")}{" "}
          <a href="https://publicbg.mjs.bg/">
            {t("directorate_corespondence")}
          </a>{" "}
          {t("via_bot_sends_message")}
        </p>
        <p>{t("bot_is_not_official")}</p>
      </div>
      <div className="mb-4">
        <div className="write-group">
          <a href="https://t.me/BGCitizenshipBot" className="write">
            <i className="fab fa-telegram" aria-hidden="true" />
            <span>{t("use_bot_telegram")}</span>
          </a>
          <Link to="/email/" className="write">
            <i className="fas fa-envelope" aria-hidden="true" />
            <span>{t("use_bot_email")}</span>
          </Link>
        </div>
      </div>
      {/* <div className="mb-4">
        <h4 className="mb-3">{t("commands")}</h4>
        <p>
          <code>/help</code> - {t("help")}
        </p>
        <p>
          <code>/login</code> - {t("enter_num_and_pin")}
        </p>
        <p>
          <code>/status</code> - {t("view_status")}
        </p>
        <p>
          <code>/clear</code> - {t("clear_data")}
        </p>
        <p>{t("if_user_blocks_bot")}</p>
      </div> */}
      <div className="mb-4">
        <h4 className="mb-3">{t("feedback")}</h4>
        <p>
          {t("help_about_the_bot")}{" "}
          <a href="mailto:bgcitizenshipbot@gmail.com">
            bgcitizenshipbot@gmail.com
          </a>
          .
        </p>
        <p>{t("help_about_the_citizenship")}</p>
      </div>
    </>
  );
}

export default Home;
